import React, { useState, useEffect,useRef } from "react";
import styles from "./Layout.module.scss";
import { Dropdown,Overlay,OverlayTrigger, Popover } from "react-bootstrap";
import logo from "../../assets/mcLogo.png";
import classNames from "classnames";
import LocalStorageService from "../../Auth/auth_service/AuthServiceStorage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
 import templateFile from "../../assets/template.xlsx";
import { VscPreview } from "react-icons/vsc";
import {
  faSignOut,
  faUserAlt,
  faGlobe,
  faDownload,
  faFilterCircleXmark,
  faSpinner,
  faListCheck,
  faStreetView,
  faTags,
} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import "./Header.css";
import { saveAs } from 'file-saver';
import AxiosService from "../../Utils/AxiosService";
import { MdDataObject, MdOutlineDriveFolderUpload, MdSearch } from "react-icons/md";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { GrTemplate } from "react-icons/gr";
import InputFileLinks from "../TableView/Components/InputFileLinks";
import { MdOutlineDescription } from "react-icons/md";
import { MdTipsAndUpdates } from "react-icons/md";

function Header() {
  const apiService = new AxiosService();
  const navigate = useNavigate();
  const location = useLocation();

  const [userName, setUserName] = useState("");
  const [allRoles, setAllRoles] = useState([]);
  const [selectLanguage, setSelectedLangage] = useState("");
  const [data, setData] = useState({});

  const [labelId, setLabelId] = useState(LocalStorageService.getSelectedLabelId());
   const[labelIdStatus, setLabelIdStatus] = useState("");
  const [previewLoader,setPreviewLoader]= useState(false);
  const [countryCodeNameMap, setCountryCodeNameMap] = useState({});
  const [updates, setUpdates] = useState([]);
  const[userId,setUserId]=useState();
  const [showUpdates, setShowUpdates] = useState(false);
  const target = useRef(null);

  const localStorageService = LocalStorageService.getService();

  useEffect(() => {
    const authVal = localStorageService.getAuthDetails();
    apiService.getAllCounties()
  .then((response) => {
    const map = {};
    response.data.forEach((c) => {
      map[c.countryCode] = c.countrName;
    });
            setCountryCodeNameMap(map);
      });

    if (authVal) {
      const id=JSON.parse(authVal)?.id;
      setUserId(id);
      const isEmailFormat = JSON.parse(authVal)?.username?.includes("@");
      if (isEmailFormat) {
        const userName = JSON.parse(authVal)?.username?.split("@")[0];
        setUserName(userName);
      } else {
        setUserName(JSON.parse(authVal).username);
      }
      const roles = JSON.parse(authVal)?.roles;
      const resultMap = roles.reduce((acc, item) => {
        const [key, value] = item.split("-"); // Split each item by '-'

        if (!acc[key]) {
          acc[key] = []; // Initialize an array for the key if it doesn't exist
        }

        acc[key].push(value); // Push the second part to the array under the key
        
        return acc;
      }, {});
      console.log(resultMap);
      setData(resultMap);
      let roleOptions = [];
      roles.forEach((element) => {
        if (element && element.split("-")[1] === "GER") {
          roleOptions.push({
            label: element.split("-")[0] + "-DE",
            value: element,
          });
        } else {
          roleOptions.push({
            label: element,
            value: element,
          });
        }
      });
      setAllRoles(roleOptions);
    } else {
      toast.error("Please login to continue");
      navigate("/landing");
    }
    apiService
    .getAllUpdates()
    .then((response) => {
      console.log(response.data);
      setUpdates(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
  }, []);

  const onLogout = () => {
    logTheLogout();
    
  };

  const logTheLogout = () =>{
    const authVal = localStorageService.getAuthDetails();

    let authDetails = JSON.parse(authVal);
    apiService
    .logTheLogout(authDetails.id)
    .then((response) => {
      console.log(response)
    LocalStorageService.removeTokens();
    setUserName("");
    navigate("/landing");
    })
    .catch((error) => {
      if (error?.response?.data?.message) {
        console.log(error.response.data.message);
      } else {
        console.log("Something went wrong!");
      }
    });
  };

  const onSelectLanguage = (element) => {
    console.log(element);
    LocalStorageService.setSelectedLanguage(element);
    const sessionStorageUpdatedEvent = new Event("sessionStorageUpdated");
    window.dispatchEvent(sessionStorageUpdatedEvent);
    element = element.includes("-GER")
      ? element.replace("-GER", "-DE")
      : element;
    setSelectedLangage(element);
  };

  const handleDownload = () => {
    if (window.confirm("Do you want to download the json file?")) {
    apiService
      .getLabelDataForDownload(labelId)
      .then((response) => {
        if (response.data) {
            const fileName = response.data?.tradeName["@none"];
            const jsonBlob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' });
            saveAs(jsonBlob, fileName+'.json');
        }
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
    }
  };

  useEffect(() => {
    const handleSessionStorageUpdate = () => {
      setLabelId(sessionStorage.getItem("selectedLabelId"));
      setLabelIdStatus(sessionStorage.getItem("selectedLabelIdStatus"));
    };

    window.addEventListener(
      "sessionStorageLabelUpdated",
      handleSessionStorageUpdate
    );

    return () => {
      window.removeEventListener(
        "sessionStorageLabelUpdated",
        handleSessionStorageUpdate
      );
    };
  }, []);

  const handleExcelDownload = () => {
    if (window.confirm("Do you want to download the excel file?")) {
      apiService
        .getLabelDataForExcelDownload(labelId)
        .then((response) => {
          console.log(response)
          if (response.data) {
           console.log("Received data type:", response.data.constructor.name);
           console.log("Received data size:", response.data.byteLength);
 const excelBlob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
 saveAs(excelBlob, 'data.xlsx');
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong!");
          }
          console.log(error)
        });
    }
  };

  const handlePreview = async () => {
    if (window.confirm("Do you want to upload and view the preview in agriguide?")) {
      setPreviewLoader(true);
      await apiService
        .generatePreviewUrl(labelId)
        .then((response) => {
          if (response.data) {
            console.log(response.data.URL, response.data.MSG);
            setPreviewLoader(false);
            if (response.data.URL !== "") {
              window.open(response.data.URL, "_blank");
            } else {
              toast.info(response.data.MSG);
              //toast.info("The preview feature is not yet activated for client "+response.data.MSG.replace("Preview feature not available for client" ,""));
            }
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong!");
          }
          setPreviewLoader(false);
        });
    }
  };

  const [buttonConfig, setButtonConfig] = useState({
    title: "Default Title",
    icon: faListCheck,
  });


  const [aggrigadebuttonConfig, setAggrigadeButtonConfig] = useState({
    title: "Default Title",
    icon: faStreetView,
  });

  const UploadFile = () => {
    const currentPath = location.pathname;
      if (currentPath.includes("/uploadFiles")) {
      navigate("/browse");
    } else{
      navigate("/uploadFiles");
    }
  };

    const turnaroundTimeReport = () => {
    const currentPath = location.pathname;
      if (currentPath.includes("/turnaroundTimeReport")) {
      navigate("/browse");
    } else{
      navigate("/turnaroundTimeReport");
    }
  };

   const cvSearch = () => {
    const currentPath = location.pathname;
      if (currentPath.includes("/cvSearch")) {
      navigate("/browse");
    } else{
      navigate("/cvSearch");
    }
  };

  const BasedOnURLRouteThePage = () => {
    const currentPath = location.pathname; // Get current path

    if (currentPath.includes("/report")) {
      setButtonConfig({ title: "Manage Labels", icon: faTags });
      navigate("/browse");
    } else if (currentPath.includes("/browse")) {
      setButtonConfig({ title: "View Master Label Report", icon: faListCheck });
      navigate("/report");
    } else {
      setButtonConfig({ title: " ", icon: faTags });
      navigate("/browse");
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes("/report")) {
      setButtonConfig({ title: "Manage Labels", icon: faTags });
    } else if (currentPath.includes("/browse")) {
      setButtonConfig({ title: "View Master Label Report", icon: faListCheck });
    } else {
      setButtonConfig({ title: " ", icon: faTags });
    }
  }, [location.pathname]);

const isNewUpdate = (date) => {
  const updateDate = new Date(date);
  const today = new Date();

  const diffInDays = (today - updateDate) / (1000 * 60 * 60 * 24);

  return diffInDays >= 0 && diffInDays <= 7;
};

const toggleUpdates = () => {
  setShowUpdates((prev) => !prev);
};

  return (
    <header className={classNames(styles.header, "shadow-sm  bg-dark pe-3 ")}>
      <section className="container-xxl my-2">
        <div className="d-flex align-items-center justify-content-between">
          <img src={logo} height={60} alt="logo" />
          {userName && (
            <div className="d-flex align-items-center">
              <div className="download-button-container me-2">
                <button
                  className="download-button"
                  title={"File Upload"}
                  onClick={() => UploadFile()}
                >
                    <MdOutlineDriveFolderUpload size="lg" />
                </button>
              </div>
              {(userId===1 &&
              <div className="download-button-container me-2">
                <button
                  className="download-button"
                  title="TAT Report"
                  onClick={() => turnaroundTimeReport()}
                >
                  <MdOutlineDescription size="lg" />
                </button>
              </div>
              )}
              <div className="download-button-container me-2">
                <button
                  className="download-button"
                  title="Ref Data"
                  onClick={() => cvSearch()}
                >
                  <MdSearch size="lg" />
                </button>
              </div>
              <div className="download-button-container me-2">
                <button
                  className="download-button"
                  title={buttonConfig.title}
                  onClick={() => BasedOnURLRouteThePage()}
                >
                    <FontAwesomeIcon icon={buttonConfig.icon} size="lg" />
                  
                </button>
              </div>

              <div className="download-button-container me-2">
                <button
                  className="download-button"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = templateFile;
                    link.download = "template.xls";
                    link.click();
                  }}
                  title="Download Template"
                >
                  <GrTemplate size={20} />
                </button>
              </div>

              {labelId && (
                <>
                  <div className="download-button-container me-2">
                    <div className="download-button-container me-2">
                      <button
                        className="download-button"
                        onClick={handlePreview}
                        title="Label Agriguide Preview"
                        disabled={previewLoader ? true : false}
                      >
                        {previewLoader ? (
                          <FontAwesomeIcon icon={faSpinner} size="lg" spin />
                        ) : (
                          <VscPreview size={25} />
                        )}
                      </button>
                    </div>
                  </div>
                  {/* <div className="download-button-container me-2">
                    <RestrictedToggleButton />
                  </div> */}
                  <div className="download-button-container me-2">
                    <InputFileLinks label={labelId} />
                  </div>
                  {( labelIdStatus!=='R'  &&
                  <div className="download-button-container">
                    <Dropdown
                      className="me-2"
                      // onClick={handleDownload}
                      title="Export"
                    >
                      <Dropdown.Toggle
                        variant="light"
                        size="sm"
                        id="dropdown-basic"
                      >
                        <FontAwesomeIcon className="me-2" icon={faDownload} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item as="button" onClick={handleDownload}>
                          <MdDataObject />
                          <span className="ml-2"> Export as JSON</span>
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          as="button"
                          onClick={handleExcelDownload}
                        >
                          <PiMicrosoftExcelLogoFill />
                          <span className="ml-2">  Excel</span>
                        </Dropdown.Item>
                        {/* <Dropdown.Divider />
                        <Dropdown.Item as="a"  href={templateFile} download="template.xls">
                       
                          <span className="ml-2"> Download Template</span>
                        </Dropdown.Item> */}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                   )} 
                </>
              )}

              <Dropdown className="me-4">
                <Dropdown.Toggle variant="light" size="sm" id="dropdown-basic">
                  <FontAwesomeIcon icon={faUserAlt} />
                  <span className="ml-2"> Welcome, {userName}</span>{" "}
                  {selectLanguage && (
                    <span className=" me-2 ml-2">({selectLanguage})</span>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown
                    as="div"
                    className="nested-dropdown-container"
                    drop="start"
                  >
                    <Dropdown.Toggle
                      as="div"
                      variant="light"
                      className="nested-dropdown"
                    >
                      {/* <FontAwesomeIcon icon={faLanguage} className="me-2" />
                      <span className="ml-2">Client</span> */}
                      <FontAwesomeIcon
                        icon={faGlobe}
                        className="me-2"
                        beatFade
                      />
                      <span className="ml-2">Organization</span>
                    </Dropdown.Toggle>
                      <Dropdown.Menu className="nested-dropdown-menu">
                      {Object.keys(data)
                        .sort((a, b) => a.localeCompare(b))
                        .map((key) => (
                          <Dropdown
                            as="div"
                            className="nested-dropdown-container1"
                            drop="start"
                            key={key}
                          >
                            <Dropdown.Toggle
                              as="div"
                              variant="light"
                              className="nested-dropdown1"
                            >
                              <span className="ml-2">{key}</span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="nested-dropdown-menu1">
                              {data[key]
                                .slice()
                                .sort((a, b) => {
                                  const codeA = a === "GER" ? "DE" : a;
                                  const codeB = b === "GER" ? "DE" : b;

                                  const nameA = countryCodeNameMap[codeA] || codeA;
                                  const nameB = countryCodeNameMap[codeB] || codeB;

                                  return nameA.localeCompare(nameB);
                                })
                                .map((subItem) => {
                                  const normalizedCode =
                                    subItem === "GER" ? "DE" : subItem;
                                  const countryName =
                                    countryCodeNameMap[normalizedCode] || normalizedCode;

                                  return (
                                    <Dropdown.Item
                                      as={Button}
                                      key={`${key}-${normalizedCode}`}
                                      onClick={() =>
                                        onSelectLanguage(`${key}-${subItem}`)
                                      }
                                    >
                                      {countryName}
                                    </Dropdown.Item>
                                  );
                                })}
                            </Dropdown.Menu>
                          </Dropdown>
                        ))}
                    </Dropdown.Menu>

                  </Dropdown>

                  <Dropdown.Divider />
                  <Dropdown.Item
                    as="button"
                    onClick={() => onSelectLanguage("")}
                  >
                    <FontAwesomeIcon icon={faFilterCircleXmark} fade />
                    <span className="ml-2"> Reset Organization</span>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item as="button" onClick={() => onLogout()}>
                    <FontAwesomeIcon icon={faSignOut} />
                    <span className="ml-2"> Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className="text-center py-2">
  <span
    ref={target}
    onClick={toggleUpdates}
    style={{ cursor: "pointer" }}
  >
    <MdTipsAndUpdates size={26} color="#f0ad4e" />
  </span>

  <Overlay
    target={target.current}
    show={showUpdates}
    placement="left"
    rootClose
    onHide={() => setShowUpdates(false)}
  >
    {(props) => (
        <Popover
  {...props}
  id="tips-popover"
>
  <Popover.Header
    as="h3"
    style={{
      background: "#05b379",
      color: "#fff",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      fontSize: "18px",
      fontWeight: "600"
    }}
  >
    <MdTipsAndUpdates className="me-2" />
    New Updates
  </Popover.Header>

  <Popover.Body
    style={{
      maxHeight: "350px",
      overflowY: "auto",
      overflowX: "hidden",
      padding: "12px",
      background: "#f8f9fa"
    }}
  >
    {updates.length > 0 ? (
      <ul className="mb-0 ps-0" style={{ listStyle: "none" }}>
       {updates
          .slice()
          .sort((a, b) => new Date(b.createDate) - new Date(a.createDate))
          .map((item) => (
          <li
            key={item.updateId}
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "10px",
              marginBottom: "10px",
              border: "1px solid #e9ecef",
              boxShadow: "0 2px 5px rgba(0,0,0,0.08)"
            }}
          >
            <div className="d-flex align-items-center flex-wrap">

              <strong
                style={{
                  color: "#212529",
                  wordBreak: "break-word",
                  flex: 1
                }}
              >
                {item.updateTitle}
              </strong>

              <small className="text-muted ms-2">
                {new Date(item.createDate).toLocaleDateString("en-GB")}
              </small>

              {isNewUpdate(item.createDate) && (
                <span className="new-badge ms-2">
                  NEW
                </span>
              )}

            </div>

            {item.updateDesc && (
              <div
                style={{
                  marginTop: "8px",
                  color: "#6c757d",
                  fontSize: "13px",
                  whiteSpace: "normal",
                  wordBreak: "break-word"
                }}
              >
                {item.updateDesc}
              </div>
            )}
          </li>
        ))}
      </ul>
    ) : (
      <div className="text-center text-muted py-3">
        No updates available.
      </div>
    )}
  </Popover.Body>
</Popover>
    )}
  </Overlay>
</div>
            </div>
          )}
        </div>
      </section>
    </header>
  );
}

export default Header;
